<template>
    <div>
        <v-container grid-list-xs>
            <v-sheet class="pa-5" elevation="3">
                <v-row class="d-flex justify-content-center py-0 mt-4 mb-6">
                    <v-col id="paymonthly-iframe-col" class="py-0">
                        <iframe
                            title="synchrony-iframe-pay-later"
                            class="iframe-container"
                            type="text/html"
                            :width="width"
                            height="877px"
                            :src="iframeUrl"
                        ></iframe>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-container>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, onMounted, onUnmounted, ref } from "vue"
    import { providerState } from "@/state"

    export default defineComponent({
        setup() {
            const iframeUrl = ref("")
            const viewportWidth = ref(window.innerWidth)

            const width = computed(() => {
                const container = document.getElementById("paymonthly-iframe-col")
                const containerWidth = container ? container.offsetWidth : viewportWidth.value
                if (containerWidth <= 800) {
                    return "320px"
                }
                return containerWidth * 0.5 + "px"
            })

            const handleResize = () => {
                viewportWidth.value = window.innerWidth
            }

            onMounted(() => {
                iframeUrl.value = providerState.applyResponse?.applyUrl || ""
                window.addEventListener("resize", handleResize)
            })

            onUnmounted(() => {
                window.removeEventListener("resize", handleResize)
            })

            return {
                iframeUrl,
                width,
            }
        },
    })
</script>

<style scoped lang="css">
    #paymonthly-iframe-col {
        display: flex;
        justify-content: center;
    }
</style>
